import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@/auth/hanko';
import { PortalShell } from '@/components/PortalShell';

// Pathless layout route (leading "_") — every route nested under it (instances/*) shares this
// guard + shell without adding a path segment. This is the "Route-Guard" from BILLING_PLAN.md
// §13: an unauthenticated visitor is bounced to /login before any protected loader/component runs.
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    const authed = await isAuthenticated();
    if (!authed) {
      throw redirect({ to: '/login' });
    }
  },
  component: () => (
    <PortalShell>
      <Outlet />
    </PortalShell>
  ),
});
